import { Grid, Heading } from '@chakra-ui/react'

import { Container } from '../components/ui/Container'
import { Section } from '../components/ui/Section'

export const ErrorPage = ({ error }: { error: string }) => {
  return (
    <Section>
      <Container>
        <Grid
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <Heading sx={{ fontSize: '2xl', fontWeight: 'medium' }} as="h2">
            {error}
          </Heading>
        </Grid>
      </Container>
    </Section>
  )
}